import React, { useId } from 'react';

import { AlineTextarea } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  label: {
    color: theme.appColors.iconsType,
    fontSize: 14,
    fontWeight: 600,
  },
}));

interface TaskDialogTextareaProps {
  label: string;
  onChange: (value: string) => void;
  placeholder: string;
  value: string;
  autoFocus?: boolean;
  minRows?: number;
  required?: boolean;
}

/** The comment, note or reason box in a task review dialog: a bold label over a plain textarea. */
export function TaskDialogTextarea({
  autoFocus = false,
  label,
  minRows = 3,
  onChange,
  placeholder,
  required = false,
  value,
}: TaskDialogTextareaProps): JSX.Element {
  const { classes } = useStyles();
  const id = useId();

  return (
    <div className={classes.field}>
      <label className={classes.label} htmlFor={id}>
        {label}
      </label>
      <AlineTextarea
        autoFocus={autoFocus}
        id={id}
        maxRows={10}
        minRows={minRows}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  );
}
